import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import CTASection from "./components/CTASection";
import AboutSection from "./components/AboutSection";
import BenefitsSection from "./components/BenefitsSection";
import PricingSection from "./components/PricingSection";
import Footer from "./components/Footer";
import ServiceDetail from "./pages/ServiceDetail";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import BlogPage from "./pages/BlogPage";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet defer={false}>
        <title>LYNKO | Connecter · Installer · Accompagner</title>
        <meta name="description" content="LYNKO — services informatiques professionnels pour TPE/PME : installation et support de PC, imprimantes, téléphonie IP, mise en réseau, dépannage et maintenance." />
        <link rel="canonical" href="https://lynko.info/" />
        <meta property="og:title" content="LYNKO | Connecter · Installer · Accompagner" />
        <meta property="og:description" content="Services informatiques professionnels pour TPE/PME : installation et support de PC, imprimantes, téléphonie IP, mise en réseau, dépannage et maintenance." />
        <meta property="og:url" content="https://lynko.info/" />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <CTASection />
        <AboutSection />
        <BenefitsSection />
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
};

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Helmet defer={false}>
        <title>Page introuvable (404) | LYNKO</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 py-24 text-center">
        <p className="text-6xl font-extrabold text-blue-500 mb-4">404</p>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Page introuvable</h1>
        <p className="text-gray-600 mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <a
          href="/"
          className="inline-flex items-center justify-center rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 transition-colors"
        >
          Retour à l'accueil
        </a>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/mentions-legales" element={<LegalPage docKey="mentions-legales" />} />
            <Route path="/politique-de-confidentialite" element={<LegalPage docKey="politique-de-confidentialite" />} />
            <Route path="/cgv" element={<LegalPage docKey="cgv" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
